import { BoilerAdapterProtocol, GraphPanel, IOExtension, } from 'z3k-config';
import { getDeviceSpec } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { removeDuplicates } from 'utils';
import { getIOExtensionUserName } from 'z3k-settings/components/service/components/device-io-model/model/device-model-type';
export var PeripheralUpdateType;
(function (PeripheralUpdateType) {
    PeripheralUpdateType["None"] = "None";
    PeripheralUpdateType["Main"] = "Main";
    PeripheralUpdateType["IO_EXTENSION"] = "IO_EXTENSION";
    PeripheralUpdateType["GRAPH_PANEL"] = "GRAPH_PANEL";
    PeripheralUpdateType["BOILER_ADAPTER"] = "BOILER_ADAPTER";
    PeripheralUpdateType["DUT"] = "DUT";
})(PeripheralUpdateType || (PeripheralUpdateType = {}));
export function getExtensionTypeNameGroup(type) {
    switch (type) {
        case PeripheralUpdateType.BOILER_ADAPTER:
            return 'Адаптеры котла';
        case PeripheralUpdateType.DUT:
            return 'Датчики уровня топлива';
        case PeripheralUpdateType.GRAPH_PANEL:
            return 'Графические панели';
        case PeripheralUpdateType.IO_EXTENSION:
            return 'Блоки расширения';
        case PeripheralUpdateType.None:
        case PeripheralUpdateType.Main:
            return 'нет';
        default:
            return type;
    }
}
function getBoilerAdapterName(type) {
    switch (type) {
        case BoilerAdapterProtocol.BSB:
            return 'BSB';
        case BoilerAdapterProtocol.EBUS:
            return 'EBUS';
        case BoilerAdapterProtocol.NAVIEN:
            return 'NAVIEN';
        case BoilerAdapterProtocol.OPENTHERM:
            return 'OPENTHERM';
        case BoilerAdapterProtocol.AUTO:
            return 'AUTO';
        default:
            return 'адаптер';
    }
}
export function getGraphPanelName(type) {
    switch (type) {
        case GraphPanel.Type.Climatic:
            return 'Climatic';
        case GraphPanel.Type.ML_753:
            return 'МЛ-753';
        default:
            return undefined;
    }
}
function getDutName() {
    return 'ДУТ';
}
function getGroups(spec) {
    const return_array = [PeripheralUpdateType.None];
    if (spec.heating.has_heating) {
        return_array.push(PeripheralUpdateType.BOILER_ADAPTER);
    }
    if (spec.io.io_extensions_supported) {
        return_array.push(PeripheralUpdateType.IO_EXTENSION);
    }
    if (spec.io.has_graph_panel_ml_753) {
        return_array.push(PeripheralUpdateType.GRAPH_PANEL);
    }
    if (spec.io.has_graph_panel_climatic) {
        return_array.push(PeripheralUpdateType.GRAPH_PANEL);
    }
    if (spec.autoscan.has_duts) {
        return_array.push(PeripheralUpdateType.DUT);
    }
    return return_array;
}
function getValue(extension_type, model_type) {
    return extension_type + ':' + model_type ?? '0';
}
export function getOptions(device_type, z3kConfig) {
    if (device_type == null || z3kConfig == null)
        return [{ text: 'Нет', value: PeripheralUpdateType.None, group: 'None' }];
    //Отсюда беру есть ли группы
    const groups = getGroups(getDeviceSpec(device_type.code, z3kConfig.device.hardware));
    //из конфига беру названия
    //Вернуть мне надо пару ExtensionType:Model
    const options = groups.flatMap((ext_type) => {
        if (ext_type === PeripheralUpdateType.BOILER_ADAPTER) {
            const temp = z3kConfig.boiler_adapters?.map((adapter) => ({
                text: getBoilerAdapterName(adapter.type),
                value: getValue(ext_type, adapter.type),
                group: getExtensionTypeNameGroup(ext_type),
            }));
            if (temp != null)
                return temp;
        }
        if (ext_type === PeripheralUpdateType.IO_EXTENSION) {
            const temp = z3kConfig.io_extensions?.map((ext) => ({
                text: getIOExtensionUserName(ext.type ?? IOExtension.Type.ZE66),
                value: getValue(ext_type, ext.type),
                group: getExtensionTypeNameGroup(ext_type),
            }));
            if (temp != null) {
                return removeDuplicates(temp);
            }
        }
        if (ext_type === PeripheralUpdateType.GRAPH_PANEL) {
            return [
                {
                    text: 'графическая панель',
                    value: getValue(ext_type, 1),
                    group: getExtensionTypeNameGroup(ext_type),
                },
            ];
        }
        if (ext_type === PeripheralUpdateType.DUT) {
            return [
                {
                    text: getDutName(),
                    value: getValue(ext_type, 1),
                    group: getExtensionTypeNameGroup(ext_type),
                },
            ];
        }
        return [];
    });
    return [{ text: 'Нет', value: PeripheralUpdateType.None, group: 'None' }, ...options];
}
